<template>
    <div class="container">
        <div class="box-title">
            <h4>
                <i class="fal fa-users"></i>
                  ຂໍ້ມູນ ໝວດໝູ່ພັດສະດຸ
                <span class="countTotal">({{listParcelCategories.length}})</span>
                <span class="btn-add">
                    <vs-button circle icon flat @click="OpenModalAdd()">
                        <i class="fal fa-plus-circle"></i>
                    </vs-button>
                </span>
            </h4>
        </div>

        <div class="center">
            <vs-table>
                <template #thead>
                    <vs-tr>
                        <vs-th>ລຳດັບ</vs-th>
                        <vs-th>ໝວດໝູ່ພັດສະດຸ</vs-th>
                        <vs-th v-if="showManualFreight">ປ້ອນຄ່າຂົນສົ່ງເອງ</vs-th>
                        <vs-th></vs-th>
                    </vs-tr>
                </template>
                <template #tbody>
                    <vs-tr
                        :key="index" :data="category"
                        v-for="(category, index) in $vs.getPage(listParcelCategories, page, max)"
                    >
                        <vs-td>{{ index + 1 }}</vs-td>
                        <vs-td :style="{width: '15%'}">
                            {{category.name}}
                        </vs-td>
                        <!-- Manual-freight allowlist: parcels of a listed category may be priced by hand by anyone. -->
                        <vs-td v-if="showManualFreight">
                            <div class="manual-freight-cell">
                                <span :class="isManualFreight(category.id) ? 'tag-allowed' : 'tag-denied'">
                                    {{ isManualFreight(category.id) ? 'ອະນຸຍາດ — ທຸກຄົນປ້ອນໄດ້' : 'ບໍ່ອະນຸຍາດ' }}
                                </span>
                                <vs-button v-if="isManualFreight(category.id)" danger flat size="small"
                                           :disabled="freightLoading" @click="OpenFreightModal(category, 'revoke')">
                                    ຍົກເລີກ
                                </vs-button>
                                <vs-button v-else flat size="small" :disabled="freightLoading"
                                           @click="OpenFreightModal(category, 'allow')">
                                    ອະນຸຍາດ
                                </vs-button>
                            </div>
                        </vs-td>
                        <vs-td style="text-align: right; width: 100px">
                            <div class="group-icon">
                                <vs-button circle icon flat @click="OpenModalEdit(category.id)">
                                    <i class="fad fa-pencil-alt"></i>
                                </vs-button>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
                <template #footer>
                    <vs-pagination v-model="page" :length="$vs.getLength(listParcelCategories, max)"/>
                    <Loading v-if="isLoading"/>
                </template>
            </vs-table>
        </div>

        <ModalAdd>
            <template v-slot="{ close }">
                <AddParcelCategories
                    @close="close"
                    @success="FetchData()"
                />
            </template>
        </ModalAdd>

        <ModalEdit>
            <template v-slot="{ close }">
                <EditParcelCategories
                    :listParcelCategory="filterParcelCategory"
                    @close="close"
                    @success="FetchData()"
                />
            </template>
        </ModalEdit>

        <vs-dialog prevent-close v-model="freightModalActive">
            <div class="con-content" :style="{ marginTop: '15px' }">
                <p :style="{ fontSize: '18px', color: '#195BFF' }">{{ freightModalText }}</p>
            </div>
            <div class="con-footer" :style="{ marginTop: '25px' }">
                <vs-button :loading="freightLoading" transparent :style="{ color: 'crimson' }" @click="ConfirmFreight()">
                    ຢືນຢັນ
                </vs-button>
                <vs-button @click="freightModalActive = false" dark transparent>ຍົກເລີກ</vs-button>
            </div>
        </vs-dialog>

    </div>
</template>

<script>
import Loading from '../../Loading';
import AddParcelCategories from './Dialog/Add';
import EditParcelCategories from './Dialog/Edit';

export default {
    components:{
        Loading,
        AddParcelCategories,
        EditParcelCategories
    },

    data:()=>({
        page: 1,
        max: 15,
        isLoading: true,


        listParcelCategories: [],
        filterParcelCategory: {},
        categoryId: '',

        /// Manual-freight allowlist (SuperAdmin only): the categories whose parcels anyone may price by hand.
        manualFreightCategoryIds: [],
        manualFreightLoaded: false,
        freightModalActive: false,
        freightTarget: null,
        freightAction: null, // 'allow' | 'revoke'
        freightLoading: false,
    }),
    computed:{
        // The allowlist API is SuperAdmin-only; the column stays hidden until it has answered.
        showManualFreight(){
            return this.$can(['SuperAdmin']) && this.manualFreightLoaded;
        },
        freightModalText(){
            const name = this.freightTarget ? this.freightTarget.name : '';
            return this.freightAction === 'allow'
                ? 'ຢືນຢັນອະນຸຍາດ: ພັດສະດຸໝວດ "' + name + '" ພະນັກງານທຸກຄົນຈະປ້ອນ ແລະ ແກ້ໄຂຄ່າຂົນສົ່ງເອງໄດ້'
                : 'ຢືນຢັນຍົກເລີກ: ພັດສະດຸໝວດ "' + name + '" ຈະໃຊ້ຄ່າຂົນສົ່ງທີ່ລະບົບຄິດໄລ່ (ຍົກເວັ້ນຄົນ ຫຼື ສາຂາທີ່ມີສິດ)';
        },
    },
    methods:{
        // ViewBranchUsers(branchId){
        //     this.$router.push({name: 'list.branch.users', params:{id: branchId}});
        // },
        OpenModalAdd(){
            this.$store.commit('modalAdd_State', true);
        },
        OpenModalEdit(categoryId){
            this.filterParcelCategory = {...this.FilterParcelCategory(categoryId)};
            this.$store.commit('modalEdit_State', true);
        },
        OpenModalDelete(categoryId){
            this.categoryId = categoryId;
            this.$store.commit('modalDelete_State', true);
        },
        FilterParcelCategory(categoryId){
            return this.listParcelCategories.filter(item=>{
                return item.id == categoryId;
            })[0] || {};
        },
        FetchManualFreight(){
            if (!this.$can(['SuperAdmin'])) return Promise.resolve();
            return this.$axios.get('manual-freight-permissions').then(res => {
                const rows = (res.data.data && res.data.data.rows) || [];
                this.manualFreightCategoryIds = rows
                    .filter(row => row.subject_type === 'parcel_category')
                    .map(row => Number(row.subject_id));
                this.manualFreightLoaded = true;
            }).catch(() => {});
        },
        isManualFreight(categoryId){
            return this.manualFreightCategoryIds.includes(Number(categoryId));
        },
        OpenFreightModal(category, action){
            this.freightTarget = category;
            this.freightAction = action;
            this.freightModalActive = true;
        },
        // One change at a time; the column reloads before the buttons come back.
        ConfirmFreight(){
            if (this.freightLoading || !this.freightTarget) return;
            this.freightLoading = true;
            const id = this.freightTarget.id;
            const request = this.freightAction === 'allow'
                ? this.$axios.post('manual-freight-permissions', { subject_type: 'parcel_category', subject_id: id, note: null })
                : this.$axios.delete('manual-freight-permissions/parcel_category/' + id);
            request.then(() => {
                // Applied here too, so a failed reload below cannot leave the old state on screen.
                if (this.freightAction === 'allow') {
                    if (!this.isManualFreight(id)) this.manualFreightCategoryIds.push(Number(id));
                    this.$notification.OpenNotification_AddItem_OnSuccess('top-right', 'dark', 3000);
                } else {
                    this.manualFreightCategoryIds = this.manualFreightCategoryIds.filter(item => item !== Number(id));
                    this.$notification.OpenNotification_DeleteItem_OnSuccess('top-right', 'danger', 3000);
                }
            }).catch(error => {
                const status = error.response ? error.response.status : null;
                this.$notification.openNotification(
                    { title: 'ສິດປ້ອນຄ່າຂົນສົ່ງເອງ', text: status === 403
                        ? 'ສະເພາະ SuperAdmin ເທົ່ານັ້ນທີ່ປ່ຽນສິດນີ້ໄດ້'
                        : 'ບັນທຶກບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່' },
                    'top-right', 'danger', 5000
                );
            }).then(() => this.FetchManualFreight()).then(() => {
                this.freightLoading = false;
                this.freightModalActive = false;
            });
        },
        FetchData(){
            this.isLoading = true;
            this.$axios.get('list-parcel-categories').then(res=>{
                setTimeout(() => {
                    this.isLoading = false;
                }, 200);
                setTimeout(()=>{
                    this.listParcelCategories = res.data.listParcelCategories;
                }, 100);
            }).catch(()=>{});
        },
    },
    created(){
        this.FetchData();
        this.FetchManualFreight();
    }
}
</script>
<style lang="scss" scoped>
.manual-freight-cell{
    display: flex;
    align-items: center;
    gap: 8px;

    .vs-button{
        margin: 0;
    }
}
.tag-allowed{
    color: #16a34a;
    font-weight: 600;
}
.tag-denied{
    color: #999;
}
// Lao inside Vuesax buttons otherwise falls back to the OS face.
button{
    font-family: inherit;
}
</style>
<style lang="scss">
.container{
    margin-top: 40px;
    .title-login{
       font-size: 20px;
       color: $primary-color;
    }
}
</style>
